import { getOverrides } from './digital-data-flag';

export default function digitalData(winObj, key, defaultValue) {
  const overrides = getOverrides(winObj?.location?.search);
  const digitalDataExportFlag = winObj?.digitalData?.export()?.flag || {};
  const flags = {
    ...digitalDataExportFlag,
    ...overrides,
  };
  const value = flags && flags[key];
  return (typeof value === 'undefined' ? defaultValue : value);
}
